import {Serializers} from '../../interfaces/serializer';
import {DataSetDimensionsGroup} from '../../interfaces/dimensions';
import {DatasetDimensionsGroupComponentObjects} from '../../classes/dataset-dimensions-group-component-object';

export const DATASET_DIMENSIONS_GROUPS_STATE_NAME = 'datasetDimensionsGroups';

export interface DataSetDimensionsGroupsState {
  serialized: Serializers<DataSetDimensionsGroup>;
  componentObjects: DatasetDimensionsGroupComponentObjects;
  loading: boolean;
  loaded: boolean;
  initialized: boolean;
}
